import { FormGroup, Label, Col, Input, FormFeedback } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import React from 'react'

const FieldBox = ({ title, children = null, className = null, error }) => (
  <FormGroup row>
    <Col sm='4' className={className}>
      <Label>{I18n.t(title)}</Label>
    </Col>

    <Col sm='8'>
      {children}
      <Input hidden invalid={error} />
      <FormFeedback>{error ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
    </Col>
  </FormGroup>
)

export default FieldBox
